<template>
  <div id="header">
    <el-col :span="24" :class="[{white:this.$store.state.isWhite},'topbar-wrap']">
      <div class="topbar-title" @click="toIndex()" style="cursor: pointer">
          <span class="logoText">语音OS · <span>开放平台</span></span>
      </div>
      <div class="topbar-account topbar-btn">
        <span class="login-span" @click="toLogin" v-if="!isLogin">登录</span>
        <div style="position: relative" v-else>
          <span class="el-dropdown-link userinfo-inner user_tel">{{ userPhone }}</span>
          <!-- 消息提醒 -->
          <span class="msgNotice" v-if="this.$store.state.messageNum != 0"></span>
          <ol class="center-ol">
            <li>
              <router-link to="/center/center-people">个人信息</router-link>
            </li>
            <li style="position: relative">
              <router-link to="/center/messages">消息</router-link>
              <span class="msgNotice msgNoticeNum" v-if="this.$store.state.messageNum != 0"></span>
            </li>
            <li>
              <router-link to="/editPassword">修改密码</router-link>
            </li>
            <li>
              <a @click="outLogin" style="cursor: pointer;">退出</a>
            </li>
          </ol>
        </div>

      </div>
      <div class="topbar-account topbar-btn">
        <ul class="el-menu-demo">
          <li class="el-menu-item">
            <a :href="this.dis_env_url">首页</a><span class="line-span">|</span>
          </li>
          <li class="el-menu-item">
            <router-link to="/hardhome" class="link-title">硬件接入</router-link><span class="line-span">|</span>
          </li>
          <li class="el-menu-item">
            <router-link to="/homePage" class="link-title">技能接入</router-link><span class="line-span">|</span>
          </li>
          <li class="el-menu-item">
            <router-link to="/tutor/ptjj" class="link-title doc">教程</router-link><span class="line-span">|</span>
          </li>
          <li class="el-menu-item" id="control">
            <a href="javascript:void (0);"  class="link-title control-active">控制台</a><span class="line-span">|</span>
            <ol>
              <li>
                <router-link to="/skillList">技能</router-link>
              </li>
              <li>
                <router-link to="/productList">智能硬件</router-link>
              </li>
            </ol>
          </li>
          <li class="el-menu-item" v-if="(this.$store.state.isDeveloper != 2)?true:false" >
            <router-link to="/developer" class="link-title">开发者认证</router-link><span class="line-span">|</span>
          </li>
        </ul>
      </div>

    </el-col>
  </div>
</template>
<script>
  export default {
    data() {
      return {
        userPhone: '',
        isDisplay:false,
        isLogin: false,
        dis_env_url: ''
      }
    },
    created() {
      this.setPhone()
        this.is_env()

    },
    mounted(){
      this.seeRouter();
      this.changeDisplay();
    },
    watch:{
      $route(to, from) {
        let path_url = to.path;
        let full_path_url = to.fullPath;
        if(path_url.toString().indexOf('/tutor') >=0){
          $('.doc').attr('data-active',true);
        }else{
          $('.doc').attr('data-active',false);
        }//技术教程相关
        if(path_url.toString().indexOf('/center') >=0 || path_url == '/editPassword'){
          $('.user_tel').attr('data-active',true);
        }else{
          $('.user_tel').attr('data-active',false);
        }//手机号相关
        if(path_url == '/productList' || path_url == '/skillList' || full_path_url.toString().indexOf('?skillId=') >=0 || full_path_url.toString().indexOf('?client_id=') >=0){
          $('.control-active').attr('data-active',true);
        }else{
          $('.control-active').attr('data-active',false);
        }//控制台相关

        if(path_url != '/hardhome' && path_url != '/homePage'){
          $('#header').css('paddingRight',0);
        }//首页头部右内边距
        $('html,body').animate({scrollTop: 0}, 200);
      }
    },
    methods: {
        is_env () {
            if (window.location.host.includes('opentw.ainirobot.com')) {
                this.dis_env_url = 'https://voiceostw.ainirobot.com'
            } else {
                this.dis_env_url = 'https://voiceos.ainirobot.com'
            }
        },
      changeDisplay(){
        if(this.$store.state.isDeveloper == 2){
          this.isDisplay = false
//          console.log(this.$store.state.isDeveloper)
        }else{
          this.isDisplay = true
//          console.log(this.$store.state.isDeveloper)
        }

      },
      seeRouter(){
        let path_url = this.$route.path;
        let full_path_url = this.$route.fullPath;
        if(path_url.toString().indexOf('/tutor') >=0){
          $('.doc').attr('data-active',true);
        }else{
          $('.doc').attr('data-active',false);
        }//技术教程相关
        if(path_url.toString().indexOf('/center') >=0 || path_url == '/editPassword'){
          $('.user_tel').attr('data-active',true);
        }else{
          $('.user_tel').attr('data-active',false);
        }//手机号相关
        if(path_url == '/productList' || path_url == '/skillList' || full_path_url.toString().indexOf('?skillId=') >=0 || full_path_url.toString().indexOf('?client_id=') >=0){
          $('.control-active').attr('data-active',true);
        }else{
          $('.control-active').attr('data-active',false);
        }//控制台相关
        $('html,body').animate({scrollTop: 0}, 200);
      },
      toLogin(){
        this.$router.push('/login');
      },
      setPhone() {
        let phone = this.getCookie('userTel');
          if (phone) {
          this.userPhone = phone;
          this.isLogin = true;
        } else {
          this.isLogin = false;
        }
//        console.log(phone)
      },
      getCookie(name) {
          if (document.location.host == 'opentw.ainirobot.com') {
              name = name + '_tw'
          }
          let arr,reg=new RegExp("(^| )"+name+"=([^;]*)(;|$)")
          if(arr=document.cookie.match(reg)) {
              return arr[2]
          } else {
              return null;
          }
      },
      removeCookie(name) {
            let flag = false
          if (document.location.host == 'opentw.ainirobot.com') {
            name = name + '_tw'
              flag = true
        }
        let exp = new Date();
        exp.setTime(exp.getTime() - 1);
        let cval = null;
        if (flag) {
            let str = name.slice(0, -3)
             cval = this.getCookie(str);

        } else {
             cval = this.getCookie(name);
        }
          if (cval != null) {
          if (document.location.host == 'open.ainirobot.com' || document.location.host == 'opentw.ainirobot.com') {
            document.cookie = name + "="+ cval + ";expires=" + exp.toGMTString() +";domain=.ainirobot.com"
          } else {
            document.cookie = name + "="+ cval + ";expires=" + exp.toGMTString()
          }
        }

      },
      outLogin() {
        this.removeCookie('token')
        this.removeCookie('userTel')
        this.setPhone();
        this.$router.push('/login')
      },
      toIndex(){
        window.location.href = this.dis_env_url;
      }
    }
  }
</script>

<style rel="stylesheet/scss" lang="scss">
  #header {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    min-width: 1200px;
    z-index: 21;
    .router-link-active {
      color: #337ab7;
    }
    span.line-span{
      color: #fff;
      position: relative;
      top: -1px;
    }
    .login-span {
      display: inline-block;
      padding: 0 23px;
      color: #dedfe3;
      text-align: center;
      transition: color 0.2s;
      cursor: pointer;
      z-index: 10;
      &:hover {
        color: #337ab7;
      }
    }
    .topbar-wrap .topbar-account .el-menu-demo .el-menu-item .doc[data-active = true],.topbar-wrap .topbar-btn .user_tel[data-active = true],.topbar-wrap .topbar-account .el-menu-demo .el-menu-item .control-active[data-active = true]{
      color: #337ab7;
    }
    .topbar-wrap .topbar-account .el-menu-demo .el-menu-item .router-link-active{
      color: #337ab7;
    }

    .topbar-wrap {
      transition: all 0.2s;
      height: 60px;
      line-height: 60px;
      padding-right: 54px;
      /*background-image: linear-gradient(to right,
        rgba(1, 2, 2, 1) 0%,
        rgba(0, 43, 66, 1) 46%,
        rgba(0, 66, 122, 1) 100%);*/
      background: #07070a;
      .topbar-btn {
        &:hover {
          .userinfo-inner {
            color: #337ab7;
          }
        }
        .userinfo-inner {
          transition: color 0.2s;
          cursor: pointer;
          display: inline-block;
          padding: 0 23px;
          text-align: center;
          height: 100%;
          color: #dedfe3;
          position: relative;
          z-index: 10;
        }
      }
      .topbar-btn {
        color: #dedfe3;
      }
      .topbar-title {
        float: left;
        text-align: left;
        width: 200px;
        padding-left: 10px;
        .logoText {
          font-size: 26px;
          color: #dedfe3;
          span {
            font-size: 18px;
          }
        }
      }
      .topbar-account {
         float: right;
         .el-menu-demo {
           background-color: transparent;
           .el-menu-item {
             height: 60px;
             line-height: 60px;
             float: left;
             list-style: none;
             transition: color 0.2s;
             padding: 0;
             &:hover {
               background: transparent;
               color: #337ab7;
             }
             &:hover a {
               color: #337ab7;
             }
             a {
               text-decoration: none;
               color: #dedfe3;
               display: inline-block;
               padding: 0 23px;
               transition: color 0.2s;
               &:hover {
                 background: transparent;
                 color: #337ab7;
               }
             }
           }
           .el-menu-item.displayNoneTrue{
             display: none;
           }
           .el-menu-item.displayNoneTrue.displayNone{
             display: inline-block;
           }
         }
       }

      .HeadPortrait {
        width: 50px;
        height: 50px;
        border-radius: 50%;
        vertical-align: middle;
      }
      .topbar-btn{
        &:hover {
          ol {
            display: block;
            opacity: 1;
          }
        }
        ol {
          display: none;
          list-style: none;
          background: #07070a;
          width: 100px;
          transition: color 1s;
          position: absolute;
          right: 16px;
          bottom: -170px;
          opacity: 0;
          z-index: 999;
          li {
            height: 40px;
            line-height: 40px;
            text-align: center;
            a {
              border: none;
              text-decoration: none;
              width: 100%;
              display: inline-block;
              height: 100%;
              padding: 0;
              color: #dedfe3;
            }
            &:hover {
              background: #07070a;
              a {
                color: #337ab7;
              }
            }
          }
        }
      }
      #control {
        &:hover {
          ol {
            display: block;
            opacity: 1;
          }
        }
        ol {
          display: none;
          list-style: none;
          background: #07070a;
          width: 100%;
          transition: color 1s;
          position: absolute;
          left: -1px;
          bottom: -80px;
          opacity: 0;
          z-index: 999;
          li {
            height: 40px;
            line-height: 40px;
            text-align: center;
            a {
              border: none;
              width: 100%;
              display: inline-block;
              height: 100%;
              padding: 0;
              color: #dedfe3;
            }
            &:hover {
              background: #07070a;
              a {
                color: #337ab7;
              }
            }
          }

        }
      }
    }
    .topbar-wrap.white{
      background: #fff;
      border-bottom: 1px solid #e5e5e5;
      span.line-span{
        color: #000;
      }
      .topbar-btn{
        color: #000;
        .login-span {
          display: inline-block;
          padding: 0 23px;
          color: #000;
          &:hover {
            color: #337ab7;
          }
        }
        &:hover {
          .userinfo-inner {
            color: #337ab7;
          }
        }
        .userinfo-inner {
          color: #000;
        }
      }
      .topbar-title {
        .logoText {
          color: #33b5ee;
          span {
            font-size: 18px;
            color: #000;
          }
        }
      }
      .topbar-account .el-menu-demo .el-menu-item .router-link-active{
        color: #337ab7;
      }
      .topbar-account {
        float: right;
        .el-menu-demo {
          .el-menu-item {
            a {
              color: #000;
              &:hover {
                color: #337ab7;
              }
            }
          }
        }
      }
      #control {
        ol {
          background: #f8f8f8;
          box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
          li {
            a {
              color: #000;
            }
            &:hover {
              background: #409EFF;
              a {
                color: #fff;
              }
            }
          }

        }
      }
      .center-ol{
        background: #f8f8f8;
        box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
        li {
          a {
            color: #000;
          }
          &:hover {
            background: #409EFF;
            a {
              color: #fff;
            }
          }
        }
      }
    }
  }
  // 消息
  .msgNotice{
    width: 8px;
    height: 8px;
    border-radius: 50%;
    // background-color: #fff;
    /*box-shadow: 0 10px #000;*/
    position: absolute;
    background-color: red;
    right: 9px;
    top:17px;
  }
  .msgNotice.msgNoticeNum{
    right: 19px;
    top:8px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Header.vue